import { Box, styled } from "@mui/material";
import { StyledCard } from "../styledCard.styled";

export const StyledDirectoryList = styled(StyledCard)(({ theme }) => ({
  gridArea: "2 / 2 / 8 / 4",
  
  ".head": {
    background: theme.color.main,
    display: "flex",
    marginBottom: ".5rem",
    alignItems: "center",
    color: theme.color.background,
    padding: ".5rem 2rem",
    justifyContent: "space-between",
    h3: {
      fontWeight: "bold",
    },
    ".editBtn": {
      cursor: "pointer",
      "&:hover": {
        color: theme.color.dark,
      },
    },
  },
  ".content": {
    paddingInline: "1rem",
    overflowY: "scroll",
    minHeight: "90%",
    ".directoryRow": {
      position: "relative",
      ".contextMenuBtn": {
        width: "3rem",
        display: "flex",
        justifyContent: "end",
        "&:hover svg": {
          color: theme.color.main
        }
      }
    },
    ".folder": {
      display: "flex",
      gap: ".25rem",
      alignItems: "center",
      justifyContent: "space-between",
      ".subDirectories": {
        paddingLeft: "1rem",
      },
    },
    ".folder:hover, .file:hover": {
      background: theme.contrast.lighter,
      ".dots": {
        display: "flex",
      }
    },
    ".fileDrag": {
      border: `2px dashed ${theme.color.main}`
    },
    ".file": {
      display: "flex",
      gap: ".25rem",
      alignItems: "center",
      justifyContent: "space-between",
    },
    ".dots": {
        display: "none"
      },
    ".data": {
        display: "flex",
        width: "100%",
      },
      "svg:hover": {
        color: theme.color.main
      }
  },
  [`@media screen and (max-width: ${theme.breakpoints.values.wide}px)`]: {
      paddingBottom: "0",
    ".head": {
      marginBottom: "0",
      padding: ".25rem 1rem",
      h3: {
        fontSize: "1.2rem",
      },
      svg: {
        width: "24px"
      },
    },
  },
}));
